import { format }    from 'date-fns';
import { parseISO }  from 'date-fns';
import { useEffect } from 'react';
import { useRef }    from 'react';
import { useState }  from 'react';
import autosize      from 'autosize';
import React         from 'react';


export default function ReviewResponse({ review, response, setReviewResponse, respondToReview }) {
  const [ responseBody, setResponseBody ] = useState('');

  async function save() {
    if (!responseBody?.trim().length)
      return;

    await respondToReview({ reviewID: review.id, body: responseBody });
    setReviewResponse({
      name:      'Owner',
      body:      responseBody,
      published: new Date().toISOString(),
      pending:   true
    });
  }

  if (response && response.body) {
    return (
      <div className="review-response">
        <span className="review-response__meta">
          {response.name ? `${response.name} responded ` : 'Response from the owner '}
          {response.published && <span className="review-response__published">{format(parseISO(response.published), 'MM/dd/yyyy')}</span>}
        </span>
        <p className="review-response__body">{response.body}</p>
      </div>
    );
  } else if (review.canRespond) {
    return (
      <div className="review-response">
        <AutosizeTextArea onChange={e => setResponseBody(e.target.value)}/>
        <button className="button" onClick={save}>Respond</button>
      </div>
    );
  } else
    return null;
}


function AutosizeTextArea({ onChange }) {
  const ref = useRef();

  useEffect(function initializeAutosize() {
    const textarea = ref.current;
    if (textarea) {
      autosize(textarea);
      return () => {
        autosize.destroy(textarea);
      };
    } else
      return () => {};
  }, [ ref ]);

  useEffect(function resizeWhenValueChanges() {
    const textarea = ref.current;
    if (textarea)
      autosize.update(textarea);
  }, [ ref ]);

  return (
    <textarea
      ref={ref}
      rows={1}
      onChange={onChange}
      onKeyUp={onChange}
      placeholder="Respond to review"
    />
  );
}
